import { render, staticRenderFns } from "./EmployeeRemovedFromCompanyTooltip.vue?vue&type=template&id=3d78cb14"
import script from "./EmployeeRemovedFromCompanyTooltip.vue?vue&type=script&lang=ts"
export * from "./EmployeeRemovedFromCompanyTooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d78cb14')) {
      api.createRecord('3d78cb14', component.options)
    } else {
      api.reload('3d78cb14', component.options)
    }
    module.hot.accept("./EmployeeRemovedFromCompanyTooltip.vue?vue&type=template&id=3d78cb14", function () {
      api.rerender('3d78cb14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tooltip/EmployeeRemovedFromCompanyTooltip.vue"
export default component.exports